import Vue from 'vue'
import area from '@/assets/area.json'
const areaOptions = area.RECORDS

/* 裁剪属性 */
function trimObject(keys, obj, defValue = undefined) {
  obj = obj || {}
  const res = {}
  for (const key of keys) {
    res[key] = obj[key] == null ? defValue : obj[key]
  }
  return
}

function delay(duration = 1500) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, duration)
  })
}

function getCountryByCode(code) {
  const item = areaOptions.find(it => it.area_code === code)
  if (item) {
    return item.en_name
  }
  return ''
}

Vue.prototype.$getCountryByCode = getCountryByCode
Vue.prototype.$trimObject = trimObject
Vue.prototype.$delay = delay

export {
  delay,
  trimObject
}
